import { motion } from "framer-motion";

export const JarvisOrb = ({ size = 56, active = false, className = "" }) => (
  <div className={`relative shrink-0 ${className}`} style={{ width: size, height: size }} aria-hidden>
    <motion.div
      className="absolute inset-0 rounded-full border border-cyan-300/40"
      style={{ borderTopColor: "rgba(34,229,255,0.95)", borderRightColor: "transparent" }}
      animate={{ rotate: 360 }}
      transition={{ duration: active ? 1.6 : 6, repeat: Infinity, ease: "linear" }}
    />
    <motion.div
      className="absolute inset-[14%] rounded-full border border-violet-400/40"
      style={{ borderBottomColor: "rgba(167,139,250,0.95)", borderLeftColor: "transparent" }}
      animate={{ rotate: -360 }}
      transition={{ duration: active ? 1.2 : 9, repeat: Infinity, ease: "linear" }}
    />
    <motion.div
      className="absolute inset-[30%] rounded-full bg-cyan-300"
      style={{ boxShadow: "0 0 18px 4px rgba(34,229,255,0.55)" }}
      animate={{ scale: active ? [1, 1.25, 1] : [1, 1.08, 1], opacity: [0.85, 1, 0.85] }}
      transition={{ duration: active ? 0.7 : 2.6, repeat: Infinity, ease: "easeInOut" }}
    />
  </div>
);

export default JarvisOrb;
